// @generated by protoc-gen-es v2.2.2 with parameter "target=ts"
// @generated from file v1/service.proto (package v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { ConfigSchema, RepoSchema } from "./config_pb";
import { file_v1_config } from "./config_pb";
import type { ResticSnapshotListSchema } from "./restic_pb";
import { file_v1_restic } from "./restic_pb";
import type { OperationEventSchema, OperationListSchema, OperationStatus } from "./operations_pb";
import { file_v1_operations } from "./operations_pb";
import type { BoolValueSchema, BytesValueSchema, Int64ValueSchema, StringListSchema, StringValueSchema } from "../types/value_pb";
import { file_types_value } from "../types/value_pb";
import type { EmptySchema } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import { file_google_api_annotations } from "../google/api/annotations_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/service.proto.
 */
export const file_v1_service: GenFile = /*@__PURE__*/
  fileDesc("ChB2MS9zZXJ2aWNlLnByb3RvEgJ2MSLXAQoKT3BTZWxlY3RvchILCgNpZHMYASADKAMSGAoLaW5zdGFuY2VfaWQYBiABKAlIAIgBARIWCglyZXBvX2d1aWQYByABKAlIAYgBARIUCgdwbGFuX2lkGAMgASgJSAKIAQESGAoLc25hcHNob3RfaWQYBCABKAlIA4gBARIUCgdmbG93X2lkGAUgASgDSASIAQFCDgoMX2luc3RhbmNlX2lkQgwKCl9yZXBvX2d1aWRCCgoIX3BsYW5faWRCDgoMX3NuYXBzaG90X2lkQgoKCF9mbG93X2lkIsABChFEb1JlcG9UYXNrUmVxdWVzdBIPCgdyZXBvX2lkGAEgASgJEigKBHRhc2sYAiABKA4yGi52MS5Eb1JlcG9UYXNrUmVxdWVzdC5UYXNrInAKBFRhc2sSDQoJVEFTS19OT05FEAASGAoUVEFTS19JTkRFWF9TTkFQU0hPVFMQARIOCgpUQVNLX1BSVU5FEAISDgoKVEFTS19DSEVDSxADEg4KClRBU0tfU1RBVFMQBBIPCgtUQVNLX1VOTE9DSxAFIkwKE0NsZWFySGlzdG9yeVJlcXVlc3QSIAoIc2VsZWN0b3IYASABKAsyDi52MS5PcFNlbGVjdG9yEhMKC29ubHlfZmFpbGVkGAIgASgIIkYKDUZvcmdldFJlcXVlc3QSDwoHcmVwb19pZBgBIAEoCRIPCgdwbGFuX2lkGAIgASgJEhMKC3NuYXBzaG90X2lkGAMgASgJIjgKFExpc3RTbmFwc2hvdHNSZXF1ZXN0Eg8KB3JlcG9faWQYASABKAkSDwoHcGxhbl9pZBgCIAEoCSJIChRHZXRPcGVyYXRpb25zUmVxdWVzdBIgCghzZWxlY3RvchgBIAEoCzIOLnYxLk9wU2VsZWN0b3ISDgoGbGFzdF9uGAIgASgDIm0KFlJlc3RvcmVTbmFwc2hvdFJlcXVlc3QSDwoHcGxhbl9pZBgBIAEoCRIPCgdyZXBvX2lkGAUgASgJEhMKC3NuYXBzaG90X2lkGAIgASgJEgwKBHBhdGgYAyABKAkSDgoGdGFyZ2V0GAQgASgJIk4KGExpc3RTbmFwc2hvdEZpbGVzUmVxdWVzdBIPCgdyZXBvX2lkGAEgASgJEhMKC3NuYXBzaG90X2lkGAIgASgJEgwKBHBhdGgYAyABKAkiRwoZTGlzdFNuYXBzaG90RmlsZXNSZXNwb25zZRIMCgRwYXRoGAEgASgJEhwKB2VudHJpZXMYAiADKAsyCy52MS5Mc0VudHJ5Ih0KDkxvZ0RhdGFSZXF1ZXN0EgsKA3JlZhgBIAEoCSKWAQoHTHNFbnRyeRIMCgRuYW1lGAEgASgJEgwKBHR5cGUYAiABKAkSDAoEcGF0aBgDIAEoCRILCgN1aWQYBCABKAMSCwoDZ2lkGAUgASgDEgwKBHNpemUYBiABKAMSDAoEbW9kZRgHIAEoAxINCgVtdGltZRgIIAEoCRINCgVhdGltZRgJIAEoCRINCgVjdGltZRgKIAEoCSI1ChFSdW5Db21tYW5kUmVxdWVzdBIPCgdyZXBvX2lkGAEgASgJEg8KB2NvbW1hbmQYAiABKAkitQUKGFN1bW1hcnlEYXNoYm9hcmRSZXNwb25zZRI8Cg5yZXBvX3N1bW1hcmllcxgBIAMoCzIkLnYxLlN1bW1hcnlEYXNoYm9hcmRSZXNwb25zZS5TdW1tYXJ5EjwKDnBsYW5fc3VtbWFyaWVzGAIgAygLMiQudjEuU3VtbWFyeURhc2hib2FyZFJlc3BvbnNlLlN1bW1hcnkSEwoLY29uZmlnX3BhdGgYCiABKAkSEQoJZGF0YV9wYXRoGAsgASgJGu4CCgdTdW1tYXJ5EgoKAmlkGAEgASgJEh0KFWJhY2t1cHNfZmFpbGVkXzMwZGF5cxgCIAEoAxIjChtiYWNrdXBzX3dhcm5pbmdfbGFzdF8zMGRheXMYAyABKAMSIwobYmFja3Vwc19zdWNjZXNzX2xhc3RfMzBkYXlzGAQgASgDEiEKGWJ5dGVzX3NjYW5uZWRfbGFzdF8zMGRheXMYBSABKAMSHwoXYnl0ZXNfYWRkZWRfbGFzdF8zMGRheXMYBiABKAMSFwoPdG90YWxfc25hcHNob3RzGAcgASgDEhkKEWJ5dGVzX3NjYW5uZWRfYXZnGAggASgDEhcKD2J5dGVzX2FkZGVkX2F2ZxgJIAEoAxIbChNuZXh0X2JhY2t1cF90aW1lX21zGAogASgDEkAKDnJlY2VudF9iYWNrdXBzGAsgASgLMigudjEuU3VtbWFyeURhc2hib2FyZFJlc3BvbnNlLkJhY2t1cENoYXJ0GoMBCgtCYWNrdXBDaGFydBIPCgdmbG93X2lkGAEgAygDEhQKDHRpbWVzdGFtcF9tcxgCIAMoAxITCgtkdXJhdGlvbl9tcxgDIAMoAxIjCgZzdGF0dXMYBCADKA4yEy52MS5PcGVyYXRpb25TdGF0dXMSEwoLYnl0ZXNfYWRkZWQYBSADKAMypwkKCEJhY2tyZXN0EjEKCUdldENvbmZpZxIWLmdvb2dsZS5wcm90b2J1Zi5FbXB0eRoKLnYxLkNvbmZpZyIAEiUKCVNldENvbmZpZxIKLnYxLkNvbmZpZxoKLnYxLkNvbmZpZyIAEi8KD0NoZWNrUmVwb0V4aXN0cxIILnYxLlJlcG8aEC50eXBlcy5Cb29sVmFsdWUiABIhCgdBZGRSZXBvEggudjEuUmVwbxoKLnYxLkNvbmZpZyIAEi4KClJlbW92ZVJlcG8SEi50eXBlcy5TdHJpbmdWYWx1ZRoKLnYxLkNvbmZpZyIAEkQKEkdldE9wZXJhdGlvbkV2ZW50cxIWLmdvb2dsZS5wcm90b2J1Zi5FbXB0eRoSLnYxLk9wZXJhdGlvbkV2ZW50IgAwARI+Cg1HZXRPcGVyYXRpb25zEhgudjEuR2V0T3BlcmF0aW9uc1JlcXVlc3QaES52MS5PcGVyYXRpb25MaXN0IgASQwoNTGlzdFNuYXBzaG90cxIYLnYxLkxpc3RTbmFwc2hvdHNSZXF1ZXN0GhYudjEuUmVzdGljU25hcHNob3RMaXN0IgASUgoRTGlzdFNuYXBzaG90RmlsZXMSHC52MS5MaXN0U25hcHNob3RGaWxlc1JlcXVlc3QaHS52MS5MaXN0U25hcHNob3RGaWxlc1Jlc3BvbnNlIgASNgoGQmFja3VwEhIudHlwZXMuU3RyaW5nVmFsdWUaFi5nb29nbGUucHJvdG9idWYuRW1wdHkiABI9CgpEb1JlcG9UYXNrEhUudjEuRG9SZXBvVGFza1JlcXVlc3QaFi5nb29nbGUucHJvdG9idWYuRW1wdHkiABI1CgZGb3JnZXQSES52MS5Gb3JnZXRSZXF1ZXN0GhYuZ29vZ2xlLnByb3RvYnVmLkVtcHR5IgASPwoHUmVzdG9yZRIaLnYxLlJlc3RvcmVTbmFwc2hvdFJlcXVlc3QaFi5nb29nbGUucHJvdG9idWYuRW1wdHkiABI1CgZDYW5jZWwSES50eXBlcy5JbnQ2NFZhbHVlGhYuZ29vZ2xlLnByb3RvYnVmLkVtcHR5IgASNAoHR2V0TG9ncxISLnYxLkxvZ0RhdGFSZXF1ZXN0GhEudHlwZXMuQnl0ZXNWYWx1ZSIAMAESOAoKUnVuQ29tbWFuZBIVLnYxLlJ1bkNvbW1hbmRSZXF1ZXN0GhEudHlwZXMuSW50NjRWYWx1ZSIAEjkKDkdldERvd25sb2FkVVJMEhEudHlwZXMuSW50NjRWYWx1ZRoSLnR5cGVzLlN0cmluZ1ZhbHVlIgASQQoMQ2xlYXJIaXN0b3J5EhcudjEuQ2xlYXJIaXN0b3J5UmVxdWVzdBoWLmdvb2dsZS5wcm90b2J1Zi5FbXB0eSIAEjsKEFBhdGhBdXRvY29tcGxldGUSEi50eXBlcy5TdHJpbmdWYWx1ZRoRLnR5cGVzLlN0cmluZ0xpc3QiABJNChNHZXRTdW1tYXJ5RGFzaGJvYXJkEhYuZ29vZ2xlLnByb3RvYnVmLkVtcHR5GhwudjEuU3VtbWFyeURhc2hib2FyZFJlc3BvbnNlIgBCLFoqZ2l0aHViLmNvbS9nYXJldGhnZW9yZ2UvYmFja3Jlc3QvZ2VuL2dvL3YxYgZwcm90bzM", [file_v1_config, file_v1_restic, file_v1_operations, file_types_value, file_google_protobuf_empty, file_google_api_annotations]);

/**
 * OpSelector is a message that can be used to select operations e.g. by query.
 *
 * @generated from message v1.OpSelector
 */
export type OpSelector = Message<"v1.OpSelector"> & {
  /**
   * @generated from field: repeated int64 ids = 1;
   */
  ids: bigint[];

  /**
   * @generated from field: optional string instance_id = 6;
   */
  instanceId?: string;

  /**
   * @generated from field: optional string repo_guid = 7;
   */
  repoGuid?: string;

  /**
   * @generated from field: optional string plan_id = 3;
   */
  planId?: string;

  /**
   * @generated from field: optional string snapshot_id = 4;
   */
  snapshotId?: string;

  /**
   * @generated from field: optional int64 flow_id = 5;
   */
  flowId?: bigint;
};

/**
 * Describes the message v1.OpSelector.
 * Use `create(OpSelectorSchema)` to create a new message.
 */
export const OpSelectorSchema: GenMessage<OpSelector> = /*@__PURE__*/
  messageDesc(file_v1_service, 0);

/**
 * @generated from message v1.DoRepoTaskRequest
 */
export type DoRepoTaskRequest = Message<"v1.DoRepoTaskRequest"> & {
  /**
   * @generated from field: string repo_id = 1;
   */
  repoId: string;

  /**
   * @generated from field: v1.DoRepoTaskRequest.Task task = 2;
   */
  task: DoRepoTaskRequest_Task;
};

/**
 * Describes the message v1.DoRepoTaskRequest.
 * Use `create(DoRepoTaskRequestSchema)` to create a new message.
 */
export const DoRepoTaskRequestSchema: GenMessage<DoRepoTaskRequest> = /*@__PURE__*/
  messageDesc(file_v1_service, 1);

/**
 * @generated from enum v1.DoRepoTaskRequest.Task
 */
export enum DoRepoTaskRequest_Task {
  /**
   * @generated from enum value: TASK_NONE = 0;
   */
  NONE = 0,

  /**
   * @generated from enum value: TASK_INDEX_SNAPSHOTS = 1;
   */
  INDEX_SNAPSHOTS = 1,

  /**
   * @generated from enum value: TASK_PRUNE = 2;
   */
  PRUNE = 2,

  /**
   * @generated from enum value: TASK_CHECK = 3;
   */
  CHECK = 3,

  /**
   * @generated from enum value: TASK_STATS = 4;
   */
  STATS = 4,

  /**
   * @generated from enum value: TASK_UNLOCK = 5;
   */
  UNLOCK = 5,
}

/**
 * Describes the enum v1.DoRepoTaskRequest.Task.
 */
export const DoRepoTaskRequest_TaskSchema: GenEnum<DoRepoTaskRequest_Task> = /*@__PURE__*/
  enumDesc(file_v1_service, 1, 0);

/**
 * @generated from message v1.ClearHistoryRequest
 */
export type ClearHistoryRequest = Message<"v1.ClearHistoryRequest"> & {
  /**
   * @generated from field: v1.OpSelector selector = 1;
   */
  selector?: OpSelector;

  /**
   * @generated from field: bool only_failed = 2;
   */
  onlyFailed: boolean;
};

/**
 * Describes the message v1.ClearHistoryRequest.
 * Use `create(ClearHistoryRequestSchema)` to create a new message.
 */
export const ClearHistoryRequestSchema: GenMessage<ClearHistoryRequest> = /*@__PURE__*/
  messageDesc(file_v1_service, 2);

/**
 * @generated from message v1.ForgetRequest
 */
export type ForgetRequest = Message<"v1.ForgetRequest"> & {
  /**
   * @generated from field: string repo_id = 1;
   */
  repoId: string;

  /**
   * @generated from field: string plan_id = 2;
   */
  planId: string;

  /**
   * @generated from field: string snapshot_id = 3;
   */
  snapshotId: string;
};

/**
 * Describes the message v1.ForgetRequest.
 * Use `create(ForgetRequestSchema)` to create a new message.
 */
export const ForgetRequestSchema: GenMessage<ForgetRequest> = /*@__PURE__*/
  messageDesc(file_v1_service, 3);

/**
 * @generated from message v1.ListSnapshotsRequest
 */
export type ListSnapshotsRequest = Message<"v1.ListSnapshotsRequest"> & {
  /**
   * @generated from field: string repo_id = 1;
   */
  repoId: string;

  /**
   * @generated from field: string plan_id = 2;
   */
  planId: string;
};

/**
 * Describes the message v1.ListSnapshotsRequest.
 * Use `create(ListSnapshotsRequestSchema)` to create a new message.
 */
export const ListSnapshotsRequestSchema: GenMessage<ListSnapshotsRequest> = /*@__PURE__*/
  messageDesc(file_v1_service, 4);

/**
 * @generated from message v1.GetOperationsRequest
 */
export type GetOperationsRequest = Message<"v1.GetOperationsRequest"> & {
  /**
   * @generated from field: v1.OpSelector selector = 1;
   */
  selector?: OpSelector;

  /**
   * limit to the last n operations
   *
   * @generated from field: int64 last_n = 2;
   */
  lastN: bigint;
};

/**
 * Describes the message v1.GetOperationsRequest.
 * Use `create(GetOperationsRequestSchema)` to create a new message.
 */
export const GetOperationsRequestSchema: GenMessage<GetOperationsRequest> = /*@__PURE__*/
  messageDesc(file_v1_service, 5);

/**
 * @generated from message v1.RestoreSnapshotRequest
 */
export type RestoreSnapshotRequest = Message<"v1.RestoreSnapshotRequest"> & {
  /**
   * @generated from field: string plan_id = 1;
   */
  planId: string;

  /**
   * @generated from field: string repo_id = 5;
   */
  repoId: string;

  /**
   * @generated from field: string snapshot_id = 2;
   */
  snapshotId: string;

  /**
   * @generated from field: string path = 3;
   */
  path: string;

  /**
   * @generated from field: string target = 4;
   */
  target: string;
};

/**
 * Describes the message v1.RestoreSnapshotRequest.
 * Use `create(RestoreSnapshotRequestSchema)` to create a new message.
 */
export const RestoreSnapshotRequestSchema: GenMessage<RestoreSnapshotRequest> = /*@__PURE__*/
  messageDesc(file_v1_service, 6);

/**
 * @generated from message v1.ListSnapshotFilesRequest
 */
export type ListSnapshotFilesRequest = Message<"v1.ListSnapshotFilesRequest"> & {
  /**
   * @generated from field: string repo_id = 1;
   */
  repoId: string;

  /**
   * @generated from field: string snapshot_id = 2;
   */
  snapshotId: string;

  /**
   * @generated from field: string path = 3;
   */
  path: string;
};

/**
 * Describes the message v1.ListSnapshotFilesRequest.
 * Use `create(ListSnapshotFilesRequestSchema)` to create a new message.
 */
export const ListSnapshotFilesRequestSchema: GenMessage<ListSnapshotFilesRequest> = /*@__PURE__*/
  messageDesc(file_v1_service, 7);

/**
 * @generated from message v1.ListSnapshotFilesResponse
 */
export type ListSnapshotFilesResponse = Message<"v1.ListSnapshotFilesResponse"> & {
  /**
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * @generated from field: repeated v1.LsEntry entries = 2;
   */
  entries: LsEntry[];
};

/**
 * Describes the message v1.ListSnapshotFilesResponse.
 * Use `create(ListSnapshotFilesResponseSchema)` to create a new message.
 */
export const ListSnapshotFilesResponseSchema: GenMessage<ListSnapshotFilesResponse> = /*@__PURE__*/
  messageDesc(file_v1_service, 8);

/**
 * @generated from message v1.LogDataRequest
 */
export type LogDataRequest = Message<"v1.LogDataRequest"> & {
  /**
   * @generated from field: string ref = 1;
   */
  ref: string;
};

/**
 * Describes the message v1.LogDataRequest.
 * Use `create(LogDataRequestSchema)` to create a new message.
 */
export const LogDataRequestSchema: GenMessage<LogDataRequest> = /*@__PURE__*/
  messageDesc(file_v1_service, 9);

/**
 * @generated from message v1.LsEntry
 */
export type LsEntry = Message<"v1.LsEntry"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string type = 2;
   */
  type: string;

  /**
   * @generated from field: string path = 3;
   */
  path: string;

  /**
   * @generated from field: int64 uid = 4;
   */
  uid: bigint;

  /**
   * @generated from field: int64 gid = 5;
   */
  gid: bigint;

  /**
   * @generated from field: int64 size = 6;
   */
  size: bigint;

  /**
   * @generated from field: int64 mode = 7;
   */
  mode: bigint;

  /**
   * @generated from field: string mtime = 8;
   */
  mtime: string;

  /**
   * @generated from field: string atime = 9;
   */
  atime: string;

  /**
   * @generated from field: string ctime = 10;
   */
  ctime: string;
};

/**
 * Describes the message v1.LsEntry.
 * Use `create(LsEntrySchema)` to create a new message.
 */
export const LsEntrySchema: GenMessage<LsEntry> = /*@__PURE__*/
  messageDesc(file_v1_service, 10);

/**
 * @generated from message v1.RunCommandRequest
 */
export type RunCommandRequest = Message<"v1.RunCommandRequest"> & {
  /**
   * @generated from field: string repo_id = 1;
   */
  repoId: string;

  /**
   * @generated from field: string command = 2;
   */
  command: string;
};

/**
 * Describes the message v1.RunCommandRequest.
 * Use `create(RunCommandRequestSchema)` to create a new message.
 */
export const RunCommandRequestSchema: GenMessage<RunCommandRequest> = /*@__PURE__*/
  messageDesc(file_v1_service, 11);

/**
 * @generated from message v1.SummaryDashboardResponse
 */
export type SummaryDashboardResponse = Message<"v1.SummaryDashboardResponse"> & {
  /**
   * @generated from field: repeated v1.SummaryDashboardResponse.Summary repo_summaries = 1;
   */
  repoSummaries: SummaryDashboardResponse_Summary[];

  /**
   * @generated from field: repeated v1.SummaryDashboardResponse.Summary plan_summaries = 2;
   */
  planSummaries: SummaryDashboardResponse_Summary[];

  /**
   * @generated from field: string config_path = 10;
   */
  configPath: string;

  /**
   * @generated from field: string data_path = 11;
   */
  dataPath: string;
};

/**
 * Describes the message v1.SummaryDashboardResponse.
 * Use `create(SummaryDashboardResponseSchema)` to create a new message.
 */
export const SummaryDashboardResponseSchema: GenMessage<SummaryDashboardResponse> = /*@__PURE__*/
  messageDesc(file_v1_service, 12);

/**
 * @generated from message v1.SummaryDashboardResponse.Summary
 */
export type SummaryDashboardResponse_Summary = Message<"v1.SummaryDashboardResponse.Summary"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int64 backups_failed_30days = 2;
   */
  backupsFailed30days: bigint;

  /**
   * @generated from field: int64 backups_warning_last_30days = 3;
   */
  backupsWarningLast30days: bigint;

  /**
   * @generated from field: int64 backups_success_last_30days = 4;
   */
  backupsSuccessLast30days: bigint;

  /**
   * @generated from field: int64 bytes_scanned_last_30days = 5;
   */
  bytesScannedLast30days: bigint;

  /**
   * @generated from field: int64 bytes_added_last_30days = 6;
   */
  bytesAddedLast30days: bigint;

  /**
   * @generated from field: int64 total_snapshots = 7;
   */
  totalSnapshots: bigint;

  /**
   * @generated from field: int64 bytes_scanned_avg = 8;
   */
  bytesScannedAvg: bigint;

  /**
   * @generated from field: int64 bytes_added_avg = 9;
   */
  bytesAddedAvg: bigint;

  /**
   * @generated from field: int64 next_backup_time_ms = 10;
   */
  nextBackupTimeMs: bigint;

  /**
   * Charts
   *
   * recent backups
   *
   * @generated from field: v1.SummaryDashboardResponse.BackupChart recent_backups = 11;
   */
  recentBackups?: SummaryDashboardResponse_BackupChart;
};

/**
 * Describes the message v1.SummaryDashboardResponse.Summary.
 * Use `create(SummaryDashboardResponse_SummarySchema)` to create a new message.
 */
export const SummaryDashboardResponse_SummarySchema: GenMessage<SummaryDashboardResponse_Summary> = /*@__PURE__*/
  messageDesc(file_v1_service, 12, 0);

/**
 * @generated from message v1.SummaryDashboardResponse.BackupChart
 */
export type SummaryDashboardResponse_BackupChart = Message<"v1.SummaryDashboardResponse.BackupChart"> & {
  /**
   * @generated from field: repeated int64 flow_id = 1;
   */
  flowId: bigint[];

  /**
   * @generated from field: repeated int64 timestamp_ms = 2;
   */
  timestampMs: bigint[];

  /**
   * @generated from field: repeated int64 duration_ms = 3;
   */
  durationMs: bigint[];

  /**
   * @generated from field: repeated v1.OperationStatus status = 4;
   */
  status: OperationStatus[];

  /**
   * @generated from field: repeated int64 bytes_added = 5;
   */
  bytesAdded: bigint[];
};

/**
 * Describes the message v1.SummaryDashboardResponse.BackupChart.
 * Use `create(SummaryDashboardResponse_BackupChartSchema)` to create a new message.
 */
export const SummaryDashboardResponse_BackupChartSchema: GenMessage<SummaryDashboardResponse_BackupChart> = /*@__PURE__*/
  messageDesc(file_v1_service, 12, 1);

/**
 * @generated from service v1.Backrest
 */
export const Backrest: GenService<{
  /**
   * @generated from rpc v1.Backrest.GetConfig
   */
  getConfig: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ConfigSchema;
  },
  /**
   * @generated from rpc v1.Backrest.SetConfig
   */
  setConfig: {
    methodKind: "unary";
    input: typeof ConfigSchema;
    output: typeof ConfigSchema;
  },
  /**
   * @generated from rpc v1.Backrest.CheckRepoExists
   */
  checkRepoExists: {
    methodKind: "unary";
    input: typeof RepoSchema;
    output: typeof BoolValueSchema;
  },
  /**
   * @generated from rpc v1.Backrest.AddRepo
   */
  addRepo: {
    methodKind: "unary";
    input: typeof RepoSchema;
    output: typeof ConfigSchema;
  },
  /**
   * @generated from rpc v1.Backrest.RemoveRepo
   */
  removeRepo: {
    methodKind: "unary";
    input: typeof StringValueSchema;
    output: typeof ConfigSchema;
  },
  /**
   * @generated from rpc v1.Backrest.GetOperationEvents
   */
  getOperationEvents: {
    methodKind: "server_streaming";
    input: typeof EmptySchema;
    output: typeof OperationEventSchema;
  },
  /**
   * @generated from rpc v1.Backrest.GetOperations
   */
  getOperations: {
    methodKind: "unary";
    input: typeof GetOperationsRequestSchema;
    output: typeof OperationListSchema;
  },
  /**
   * @generated from rpc v1.Backrest.ListSnapshots
   */
  listSnapshots: {
    methodKind: "unary";
    input: typeof ListSnapshotsRequestSchema;
    output: typeof ResticSnapshotListSchema;
  },
  /**
   * @generated from rpc v1.Backrest.ListSnapshotFiles
   */
  listSnapshotFiles: {
    methodKind: "unary";
    input: typeof ListSnapshotFilesRequestSchema;
    output: typeof ListSnapshotFilesResponseSchema;
  },
  /**
   * Backup schedules a backup operation. It accepts a plan id and returns empty if the task is enqueued.
   *
   * @generated from rpc v1.Backrest.Backup
   */
  backup: {
    methodKind: "unary";
    input: typeof StringValueSchema;
    output: typeof EmptySchema;
  },
  /**
   * DoRepoTask schedules a repo task. It accepts a repo id and a task type and returns empty if the task is enqueued.
   *
   * @generated from rpc v1.Backrest.DoRepoTask
   */
  doRepoTask: {
    methodKind: "unary";
    input: typeof DoRepoTaskRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Forget schedules a forget operation. It accepts a plan id and returns empty if the task is enqueued.
   *
   * @generated from rpc v1.Backrest.Forget
   */
  forget: {
    methodKind: "unary";
    input: typeof ForgetRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Restore schedules a restore operation.
   *
   * @generated from rpc v1.Backrest.Restore
   */
  restore: {
    methodKind: "unary";
    input: typeof RestoreSnapshotRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Cancel attempts to cancel a task with the given operation ID. Not guaranteed to succeed.
   *
   * @generated from rpc v1.Backrest.Cancel
   */
  cancel: {
    methodKind: "unary";
    input: typeof Int64ValueSchema;
    output: typeof EmptySchema;
  },
  /**
   * GetLogs returns the keyed large data for the given operation.
   *
   * @generated from rpc v1.Backrest.GetLogs
   */
  getLogs: {
    methodKind: "server_streaming";
    input: typeof LogDataRequestSchema;
    output: typeof BytesValueSchema;
  },
  /**
   * RunCommand executes a generic restic command on the repository.
   *
   * @generated from rpc v1.Backrest.RunCommand
   */
  runCommand: {
    methodKind: "unary";
    input: typeof RunCommandRequestSchema;
    output: typeof Int64ValueSchema;
  },
  /**
   * GetDownloadURL returns a signed download URL given a forget operation ID.
   *
   * @generated from rpc v1.Backrest.GetDownloadURL
   */
  getDownloadURL: {
    methodKind: "unary";
    input: typeof Int64ValueSchema;
    output: typeof StringValueSchema;
  },
  /**
   * Clears the history of operations
   *
   * @generated from rpc v1.Backrest.ClearHistory
   */
  clearHistory: {
    methodKind: "unary";
    input: typeof ClearHistoryRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * PathAutocomplete provides path autocompletion options for a given filesystem path.
   *
   * @generated from rpc v1.Backrest.PathAutocomplete
   */
  pathAutocomplete: {
    methodKind: "unary";
    input: typeof StringValueSchema;
    output: typeof StringListSchema;
  },
  /**
   * GetSummaryDashboard returns data for the dashboard view.
   *
   * @generated from rpc v1.Backrest.GetSummaryDashboard
   */
  getSummaryDashboard: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof SummaryDashboardResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_service, 0);

